import data from "../data/mobileApp.json";


const kotlinQuiz = data.kotlin;
const swiftQuiz = data.swift;
const dartQuiz = data.dart;


export {kotlinQuiz, swiftQuiz, dartQuiz};